import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"container-inner\">\n  {{yield}}\n</div>\n",{ moduleName: "client-portal/components/layout/container.hbs" })